export const checkinStatusTranslations = {
  not_checked_in: 'Chưa điểm danh',
  checked_in: 'Đã điểm danh',
  checked_out: 'Đã tan làm',
}; 